<template>
  <lu-vbox lu-flex-wrap lu-vcenter qclass='vpad-in-20' style='padding: 15px;color: black;'>
        <lu-hbox lu-vcenter >
          <lu-item lu-flex style='width:120px;'>{{ $t('Show Mode') }} : </lu-item>
          <el-switch v-model='mode'
            active-value='1' inactive-value='2'
            active-text='Large' inactive-text="Small"
          />
        </lu-hbox>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import { mapState } from 'vuex';

export default {
  name: 'SettingsMode',
  components: { LuHbox, LuVbox, LuItem },
  props: [ 'panel', 'panelId' ],
  computed: {
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    mode: {
      get () {
        let idx = this.panelConfig.findIndex(item => item.id === this.panelId)
        if (idx !== -1) {
          return this.panelConfig[idx].options.mode
        }
        return 1
      },
      set (val) {
        this.panel.options.mode = val
        this.$store.dispatch('settingsMonitor/changeOptionSetting', this.panel)
      }
    }
  }
}
</script>

<style lang='scss'>


</style>